import { Flex } from 'components/shared/flex'
import { Probe } from 'entities/probe'
import { Badge } from 'react-bootstrap'
import { ViewModel } from 'view_models/view_model'

export class ProbeViewModel extends ViewModel<Probe> {
    public tagsView = () => {
        return (
            <Flex alignItems="center" flexWrap="wrap">
                {this.object.tags?.map((tag) => {
                    return (
                        <Badge style={{ minWidth: 60 }} key={tag.id} bg={'secondary'}>
                            {tag.name}
                        </Badge>
                    )
                })}
            </Flex>
        )
    }
    public statusView = () => {
        return (
            <Badge style={{ minWidth: 60 }} key={`${this.object.id}-status`} bg={this.object.isActive ? 'primary' : 'secondary'}>
                {this.object.isActive ? 'active' : 'not active'}
            </Badge>
        )
    }
}